import actionTypes from '../constants/actionTypes';
import createFetchingHandlers from '../../../../utils/createFetchingHandlers';
import createListReducer from '../../../../utils/createListReducer';

const { STATS_ITEMS_FETCH, STATS_ITEMS_SUCCESS, STATS_ITEMS_ERROR } = actionTypes;

const initialState = {
  data: [],
  metadata: {},
};

const fetchingData = createFetchingHandlers([STATS_ITEMS_FETCH, STATS_ITEMS_SUCCESS, STATS_ITEMS_ERROR], () => ['metadata', 'fetchingData']);
const getDataHandler = {
  [STATS_ITEMS_SUCCESS]: (state, action) => {
    const outputState = { ...state };
    outputState.data = { ...action?.payload };
    return { ...outputState };
  },
};

export default createListReducer(initialState, [fetchingData, getDataHandler]);
